import React from 'react';

import { FareEstimateFormLabel } from '../domain/configs/Store.store';
import { useFareEstimateContent } from '../domain/context/FareEstimateContentContext';

import RequirementCardCmp from './RequirementCardCmp';

type identifiers = {
  id: string;
};
interface FareEstimateRequirementCmpProps {
  selectedRequirement: 'personal' | 'business' | null;
  requirementHandler: (
    flag: boolean,
    requirement?: 'personal' | 'business',
  ) => void;
  identifiers: identifiers;
}

const FareEstimateRequirmentCmp: React.FC<FareEstimateRequirementCmpProps> = ({
  selectedRequirement,
  requirementHandler,
  identifiers: { id },
}) => {
  const { spot_fare_estimate_content: spot } = useFareEstimateContent();
  const handleRequirementChange = (requirement: 'personal' | 'business') => {
    requirementHandler(false, requirement);
  };

  return (
    <div
      id={id}
      className="bg-white p-[2.6rem_2rem_0.01rem] box-border rounded-t-[1.6rem] w-full pb-6"
    >
      <div className="mb-6 flex gap-1 text-2xl normal-case">
        {spot.requirement_title}
        <span className="text-red-500">*</span>
      </div>
      <RequirementCardCmp
        identifiers={{ id: 'business', className: 'mb-6' }}
        cardContent={{
          icon: spot.business_option.icon.url,
          heading: spot.business_option.title,
          description: spot.business_option.desc,
        }}
        isSelected={selectedRequirement === FareEstimateFormLabel.business}
        onChange={() => handleRequirementChange('business')}
      />
      <RequirementCardCmp
        identifiers={{ id: 'personal' }}
        cardContent={{
          icon: spot.personal_option.icon.url,
          heading: spot.personal_option.title,
          description: spot.personal_option.desc,
        }}
        isSelected={selectedRequirement === FareEstimateFormLabel.personal}
        onChange={() => handleRequirementChange('personal')}
      />
    </div>
  );
};

export default FareEstimateRequirmentCmp;
